import { type FC } from 'react'
import { DeltaTrialTimelineContainer } from '../DeltaTrial/Timeline/DeltaTrialTimelineContainer'
import { DeltaTrialTimelineElement } from '../DeltaTrial/Timeline/DeltaTrialTimelineElement'
import { formatProratedPrice, getReminderDay } from '../DeltaTrial/utils'

interface TrialTimelineProps {
  featureName: string
  deltaTrialDays: number
  proratedPrice: number | null
  showDay2?: boolean
}

export const TrialTimeline: FC<TrialTimelineProps> = ({ featureName, deltaTrialDays, proratedPrice, showDay2 = true }) => {
  return (
    <DeltaTrialTimelineContainer>
      <DeltaTrialTimelineElement day='Today' text={`Start using ${featureName} immediately — no restrictions.`} icon='bi-rocket-takeoff-fill' />
      {showDay2 && <DeltaTrialTimelineElement day='Day 2' text="You'll receive setup guides and resources to get started quickly." icon='bi-gear-fill' />}
      <DeltaTrialTimelineElement
        day={`Day ${getReminderDay(deltaTrialDays)}`}
        text="You'll get a reminder 14 days before the trial is up."
        icon='bi-bell-fill'
      />
      <DeltaTrialTimelineElement
        day={`Day ${deltaTrialDays}`}
        text={`Trial ends. Continue with the ${formatProratedPrice(proratedPrice)} prorated charge or cancel.`}
        icon='bi-star-fill'
      />
    </DeltaTrialTimelineContainer>
  )
}
